//you need to import both vue and vuex, as both are used here
import Vue from 'vue';
import Vuex from 'vuex';
import sharedMutations from 'vuex-shared-mutations';
//then you use Vuex
Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    fullName: null,
    email: null,
    roles: null,
    timezone: null,
    dateFormat: null,
    color: null,
    imageChanged: null,
    imagePath: null,
  },
  mutations: {
    initialiseStore(state) {
      if (localStorage.roles) {
        state.roles = localStorage.roles;
      }
      if (localStorage.timezone) {
        state.timezone = localStorage.timezone;
      }
      if (localStorage.dateFormat) {
        state.dateFormat = localStorage.dateFormat;
      }
      if (localStorage.userfullname) {
        state.fullName = localStorage.userfullname;
      }
      if (localStorage.email) {
        state.email = localStorage.email;
      }
      if (localStorage.color) {
        state.color = localStorage.color;
      }
      if (localStorage.imagePath) {
        state.imagePath = localStorage.imagePath;
      }
      if (localStorage.firtTime) {
        state.firtTime = localStorage.firtTime === 'true';
      }
      if (localStorage.provider) {
        state.provider = localStorage.provider;
      }
      state.imageChanged = false;
    },
    setRoles(state, roles) {
      if (roles) {
        localStorage.roles = roles;
        state.roles = roles;
      } else {
        localStorage.removeItem('roles');
        state.roles = null;
      }
    },
    setTimezone(state, timezone) {
      if (timezone) {
        localStorage.timezone = timezone;
        state.timezone = timezone;
      } else {
        localStorage.removeItem('timezone');
        state.timezone = null;
      }
    },
    setDateFormat(state, dateFormat) {
      if (dateFormat) {
        localStorage.dateformat = dateFormat;
        state.dateFormat = dateFormat;
      } else {
        localStorage.removeItem('dateformat');
        state.dateFormat = null;
      }
    },
    setFullName(state, fullName) {
      if (fullName) {
        localStorage.userfullname = fullName;
        state.fullName = fullName;
      } else {
        localStorage.removeItem('userfullname');
        state.fullName = null;
      }
    },
    setEmail(state, email) {
      if (email) {
        localStorage.email = email;
        state.email = email;
      } else {
        localStorage.removeItem('email');
        state.email = null;
      }
    },
    setColor(state, color) {
      if (color) {
        localStorage.color = color;
        state.color = color;
      } else {
        localStorage.removeItem('color');
        state.color = null;
      }
    },
    setImagePath(state, imagePath) {
      if (imagePath) {
        localStorage.imagePath = imagePath;
        state.imagePath = imagePath;
      } else {
        localStorage.removeItem('imagePath');
        state.imagePath = null;
      }
    },
    setImageChanged(state, image) {
      state.imageChanged = image;
    },
  },
  getters: {
    roles: state => {
      return state.roles ? state.roles : null;
    },
    timezone: state => {
      return state.timezone ? state.timezone : 'Asia/Dubai';
    },
    dateFormat: state => {
      return state.dateFormat ? state.dateFormat : 'DD MMM YY';
    },
    fullName: state => {
      return state.fullName ? state.fullName : 'Undefined';
    },
    email: state => {
      return state.email ? state.email : 'Undefined';
    },
    color: state => {
      return state.color ? state.color : 'primary';
    },
    imageChanged: state => {
      return state.imageChanged ? state.imageChanged : false;
    },
    imagePath: state => {
      return state.imagePath ? state.imagePath : null;
    },
  },
  plugins: [
    sharedMutations({
      predicate: [
        'setRoles',
        'setTimezone',
        'setDateFormat',
        'setFullName',
        'setEmail',
        'setColor',
        'setImageChanged',
        'setImagePath',
      ],
    }),
  ],
});
